
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
  flex-direction:column;
  flex:1;
  width:100%;
}

outline-styled-text-baseline{
  --body-color:var(--alert-text-color, var(--brand-white));
}

.emergency-alert-button{
  display:flex;
  flex:1;
  justify-content:space-between;
  align-items:center;
  background-color:var(--brand-red-700);
  padding-block:var(--spacing-6);
  padding-inline:calc(5% - 0.5rem);
  color:var(--brand-white);
  color:var(--alert-text-color, var(--brand-white));
  border:none;
}

.emergency-alert-button .toggle-icon{
    transition:transform 0.2125s ease;
  }

.emergency-alert-button:hover .toggle-icon{
      transform:scale(1.2);
    }

.emergency-alert-button:focus{
    outline:none;
  }

.emergency-alert-button:focus-visible{
    outline:2px solid var(--brand-white);
    outline:2px solid var(--alert-text-color, var(--brand-white));
    outline-offset:-4px;
    z-index:99;
  }

.emergency-alert-content{
  display:flex;
  max-height:0;
  flex:1;
  overflow:hidden;
  flex-direction:column;
  background-color:var(--brand-red-700);
  padding:0;
  color:var(--brand-white);
  color:var(--alert-text-color, var(--brand-white));
  gap:var(--spacing-6);
  transition:all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  padding-right:calc(10% - 1rem);
}

.emergency-alert-content.open{
    padding-bottom:var(--spacing-6);
    padding-inline:calc(5% - 0.5rem);
  }

.title-container{
  display:inline-flex;
  align-items:center;
  gap:var(--spacing-4);
}

.btn{
  --outline-button--primary-bg-color--computed:var(--brand-white);
  --outline-button--primary-bg-color-focus--computed:var(--brand-white);
  --outline-button--primary-color--computed:black;
  --outline-button--primary-color-focus--computed:black;
  --outline-button--secondary-bg-color--computed:var(--brand-white);
  --outline-button--secondary-bg-color-focus--computed:var(--brand-white);
  --outline-button--secondary-color--computed:black;
  --outline-button--secondary-color-focus--computed:black;
}
`;